import AssignmentPage from './assignment';

export default AssignmentPage;
